import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/brbates86'
      className='link footer__link'
    >
      created by brb coding & web developement
    </a>
  </footer>
)

export default Footer